
  import { mapState } from 'vuex'

  import AppSpinner from '@loavies/component-library/dist/app-spinner'
  import AppIconTextBlock from '@loavies/component-library/dist/app-icon-text-block'
  import IconWishlist from '@loavies/component-library/dist/icons/icon-wishlist'
  import AppButton from '@loavies/component-library/dist/app-button'

  export default {
    components: {
      AppSpinner,
      AppIconTextBlock,
      IconWishlist,
      AppButton,
    },
    data() {
      return {
        isLoading: true,
        wishlistItems: null,
      }
    },
    head() {
      return {
        title: this.$pageHelperService.getFormattedPageTitle(this.$t('wishlist')),
      }
    },
    computed: {
      ...mapState({
        showLargeProductCards: state => state.showLargeProductCards,
        wishlist: state => state.wishlist.wishlist,
      }),
      hasWishlistItems() {
        return this.wishlist?.length > 0
      },
      allListingsCategory() {
        const categories = this.$staticDataService.globalNavigation?.navigation

        return categories?.find(category => category.showAllListings)
      },
      listingsRoute() {
        return this.localePath(this.allListingsCategory?.link)
      },
    },
  }
